import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { FormInstance } from "antd";

import { MergedColumnType } from "../../../../../ui/table/utils/types";
//Locale
import "dayjs/locale/uk";

dayjs.extend(customParseFormat);
dayjs.locale("uk");

export const setProfile: Record<
  string,
  (form: FormInstance, rowData: MergedColumnType) => void
> = {
  "/profile/menu-tabs": (form, rowData) => {
    form.setFieldsValue({
      nameFolder: rowData.name,
    });
  },
};
